import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Pojedynczy kafelek z ofertą
const OfertaItem = ({ title, image, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay }}
      className="relative group overflow-hidden h-72 md:h-80 lg:h-96"
    >
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover brightness-75 group-hover:brightness-100 group-hover:scale-105 transition-all duration-500"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 transition-opacity duration-500 group-hover:opacity-0">
        <img src="/images/logoaccent.png" alt="Logo" className="w-20 h-20 mb-2" />
        <hr className="border-accent border-2 w-10 mb-2" />
        <h3 className="text-lg md:text-xl font-semibold">{title}</h3>
      </div>
    </motion.div>
  );
};

// Główna sekcja oferty
export default function OfertaSection() {
  const items = [
    { title: "Chrzciny i Komunie", image: "/images/foto16.jpg" },
    { title: "Wesela i Bankiety", image: "/images/foto10.jpg" },
    { title: "Imprezy okolicznościowe", image: "/images/foto23.jpg" },
    { title: "Stypy", image: "/images/foto12.jpg" }
  ];

  return (
    <section className="bg-light2 py-20 px-4" id="oferta">
      <div className="max-w-8xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading text-center text-accent mb-12 tracking-wide">
          <span className="inline-block border-t border-b-2 border-accent px-6 py-2">
            OFERTA
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-[90%] mx-auto">
          {items.map((item, idx) => (
            <OfertaItem
              key={idx}
              title={item.title}
              image={item.image}
              delay={idx * 0.2}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
